import { $ } from '../utils/Utils';

const iframeRatio = (() => {
  const config = {
    triggers: [...$('.js-iframeRatio')],
  };

  const updateMarkup = (iframe) => {
    // create element
    const container = document.createElement('div');
    // add class to new element
    container.classList.add('iframe', '-youtube');
    // insert newly created element before iframe
    iframe.parentNode.insertBefore(container, iframe);
    // move iframe into newly created element
    container.appendChild(iframe);
    // remove attributes for width and height
    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
  };

  const handleIframe = (trigger) => {
    // find any iframe within the container
    // at the moment, I'm just going to handle video iframe from youtube and vimeo
    const youtube = [...trigger.querySelectorAll('iframe[src*="youtube"]')];
    const vimeo = [...trigger.querySelectorAll('iframe[src*="vimeo"]')];
    const iframes = [...youtube, ...vimeo];

    if (iframes.length > 0) {
      iframes.forEach(iframe => updateMarkup(iframe));
    }
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      handleIframe(trigger);
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default iframeRatio.init();
